module.exports = __webpack_public_path__ + "img/Meli.640063d2.png";